module.exports = __webpack_public_path__ + "static/media/loader.6aad72de.svg";